import PropTypes from 'prop-types';
import { css, etiColors, mediaQueries } from '@eti/styles';
import { TripCharacteristics } from '@eti/types';
import TripDetailsContent from '../../../../widgets/trip-details/components/TripDetailsContent';
import { bounds as boundsPropTypes } from '../../../../widgets/trip-details/propTypes';
import TripDetailsExpansionButtons from '../../../../widgets/trip-details/components/TripDetailsExpansionButtons';
import UrgencyFlag from './UrgencyFlag';

export const resultTripDetailsStyles = (isExpanded, isBaggageIncluded) => css`
  &:focus {
    outline: none;
  }

  .tripDetailsBound {
    background-color: ${etiColors.white};
    border-bottom: ${isExpanded ? 'none' : `1px dotted ${etiColors.grayScale[7]}`};
    cursor: ${isExpanded ? 'default' : 'pointer'};
    padding-bottom: ${isBaggageIncluded ? '8px' : '20px'};
    position: relative;

    @media ${mediaQueries.medium.up} {
      padding-bottom: 0;
    }
  }
`;

const eventSegmentListStyles = css`
  background-color: ${etiColors.white};
  padding: 16px;
`;

const getNumberOfSegments = (bounds) =>
  bounds.reduce((acc, bound) => acc + bound.segments.length, 0);

const ResultTripDetails = ({
  bounds,
  flightId,
  isBaggageIncluded,
  isExpanded,
  isMultiStop,
  isRyanAirTicketingOrMarketingCarrierPresent,
  isVI,
  language,
  numberOfSeatsLeft,
  onClick,
  shouldShowSeatsLeftNotificationMessage,
  tripCharacteristics,
}) => {
  const isOneWayTripAndOneSegment = getNumberOfSegments(bounds) === 1;
  return (
    <TripDetailsContent
      bounds={bounds}
      className={resultTripDetailsStyles(isOneWayTripAndOneSegment, isBaggageIncluded)}
      eventSegmentListStyles={eventSegmentListStyles}
      flightId={flightId}
      isExpanded={isOneWayTripAndOneSegment || isExpanded}
      isMultiStop={isMultiStop}
      isRyanAirTicketingOrMarketingCarrierPresent={isRyanAirTicketingOrMarketingCarrierPresent}
      isVI={isVI}
      language={language}
      onClick={onClick}
      tripCharacteristics={tripCharacteristics}
    >
      {!isOneWayTripAndOneSegment && (
        <TripDetailsExpansionButtons isExpanded={isExpanded} isVI={isVI} />
      )}
      {shouldShowSeatsLeftNotificationMessage && (
        <UrgencyFlag numberOfSeatsLeft={numberOfSeatsLeft} />
      )}
    </TripDetailsContent>
  );
};

ResultTripDetails.propTypes = {
  bounds: boundsPropTypes,
  flightId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isBaggageIncluded: PropTypes.bool,
  isExpanded: PropTypes.bool,
  isMultiStop: PropTypes.bool,
  isRyanAirTicketingOrMarketingCarrierPresent: PropTypes.bool,
  isVI: PropTypes.bool,
  language: PropTypes.string,
  numberOfSeatsLeft: PropTypes.number,
  onClick: PropTypes.func,
  shouldShowSeatsLeftNotificationMessage: PropTypes.bool,
  tripCharacteristics: PropTypes.arrayOf(TripCharacteristics),
};

export default ResultTripDetails;
